// extracted by mini-css-extract-plugin
export default {"\t":"mP47X659Y72CFuMA1ajS","gradientBackground":"rtQ8efZeLqVQCwhu2s1Q","gradient":"PpJKdq_LqOkbqmJD3_n_"};